/** Picker curato (categorie, nessuna ricerca). */
export const STAFF_EMOJI_CATEGORIES: { label: string; emojis: string[] }[] = [
  {
    label: 'Sorrisi',
    emojis: ['😀', '😃', '😄', '😁', '😅', '😂', '🙂', '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😋', '😛', '🤔', '😐', '😑', '😶'],
  },
  {
    label: 'Gestualità',
    emojis: ['👍', '👎', '👌', '✌️', '🤞', '🤝', '🙏', '👏', '🙌', '💪', '👀', '🤷', '🤦', '💁'],
  },
  {
    label: 'Cuori',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '💔', '❣️', '💕', '💞', '💓', '💗', '💖'],
  },
  {
    label: 'Lavoro',
    emojis: ['📎', '📁', '📋', '✅', '❌', '⚠️', '⏰', '📅', '📞', '✉️', '📧', '🔔', '🔒', '🔑'],
  },
  {
    label: 'Simboli',
    emojis: ['✨', '🔥', '💡', '🎯', '📌', '⭐', '🌟', '☀️', '🌙', '☂️', '❓', '❗', '€', '©'],
  },
];
